<template>
  <ClientOnly>
    <Teleport to="#__nuxt">
      <div class="fixed left-0 top-0 z-30 mx-auto w-full">
        <div
          :key="1"
          class="flex h-[calc(100vh-0rem)] items-center justify-center bg-[--theme-darkest]"
        >
          <div
            class="flex flex-col items-center justify-center gap-y-5"
          >
            <UBookLoader />
            <p class="font-national2 text-2xl text-white">
              Laster inn..
            </p>
          </div>
        </div>
      </div>
    </Teleport>
  </ClientOnly>
</template>
